var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrkester(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 40,
    viewBox: "0 0 167 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.95433 40 0 31.0457 0 20C0 8.95433 8.95433 0 20 0C31.0457 0 40 8.95433 40 20Z",
    fill: "#FF3200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6052 20L12.6961 21.0909L18.9922 18.9923L21.0909 12.6963L20 11.6052L11.6052 20ZM18.909 27.3037L20 28.3946L28.3946 20L27.3036 18.9091L21.0077 21.0077L18.909 27.3037ZM20 32L15.9923 27.9923L17.9845 22.0155L12.0077 24.0077L8 20L20 8L24.0077 12.0077L22.0153 17.9845L27.9923 15.9923L32 20L20 32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7865 19.9353C61.7865 16.2021 60.2261 13.7355 56.4745 13.7355C52.7562 13.7355 51.1958 16.2021 51.1958 19.9353C51.1958 23.8686 52.7562 26.3351 56.4745 26.3351C60.2261 26.3351 61.7865 23.8686 61.7865 19.9353ZM46.415 19.9353C46.415 13.5021 50.2662 9.53564 56.4745 9.53564C62.7825 9.53564 66.5341 13.5021 66.5341 19.9353C66.5341 26.402 62.9485 30.4685 56.4745 30.4685C50.0338 30.4685 46.415 26.402 46.415 19.9353Z",
    fill: "#3C002D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7256 30.0021V14.2023H73.0084V19.3356H73.3736C74.3696 14.9358 75.6976 14.0356 77.7558 14.0356H78.2206V19.2356H77.2912C74.1372 19.2356 73.2408 20.169 73.2408 22.969V30.0021H68.7256Z",
    fill: "#3C002D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6937 20.3687H85.9221L89.9393 14.202H95.0853V14.5687L89.4745 21.9019L95.4173 29.6352V30.0019H90.2713L85.8557 23.6687H84.6937V30.0019H80.1787V10.0049H84.6937V20.3687Z",
    fill: "#3C002D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8666 20.8355H106.44C106.374 18.3689 105.345 17.1689 103.319 17.1689C101.261 17.1689 100.099 18.2355 99.8666 20.8355ZM95.3848 22.4355C95.3848 16.9689 98.3396 13.769 103.452 13.769C108.299 13.769 110.59 16.6355 110.59 21.0022C110.59 21.6689 110.557 22.3022 110.491 23.1355H99.8336C100.099 25.6687 101.261 26.8022 103.419 26.8022C105.544 26.8022 106.208 25.8022 106.606 24.6022L110.391 25.6355C109.694 28.3687 107.868 30.4354 103.386 30.4354C98.6384 30.4354 95.3848 27.802 95.3848 22.4355Z",
    fill: "#3C002D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.885 25.4689L115.935 24.6355C116.334 26.3687 117.396 27.2689 119.355 27.2689C120.882 27.2689 121.645 26.7689 121.679 25.7355C121.679 24.7689 121.048 24.2355 118.16 23.6689C113.844 22.7355 112.383 21.3022 112.383 18.6022C112.383 15.569 114.541 13.769 118.989 13.769C123.571 13.769 125.065 15.569 125.629 18.3355L121.612 19.1689C121.247 17.5355 120.517 16.9024 118.89 16.9024C117.396 16.9024 116.666 17.4024 116.666 18.3355C116.666 19.2022 117.097 19.8355 119.919 20.4022C124.833 21.4355 126.028 23.0689 126.028 25.5354C126.028 28.6022 124.003 30.4687 119.255 30.4687C113.943 30.4687 112.316 28.3354 111.885 25.4689Z",
    fill: "#3C002D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.949 17.802H127.023V14.202H128.949V10.0049H133.464V14.202H137.614V17.802H133.464V24.302C133.464 25.5687 133.929 26.2019 135.29 26.2019C135.987 26.2019 136.751 26.0019 137.349 25.802L137.847 29.8685C136.651 30.2354 135.855 30.4685 134.128 30.4685C130.476 30.4685 128.949 28.0352 128.949 25.0352V17.802Z",
    fill: "#3C002D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.557 20.8355H150.131C150.064 18.3689 149.035 17.1689 147.01 17.1689C144.951 17.1689 143.789 18.2355 143.557 20.8355ZM139.075 22.4355C139.075 16.9689 142.03 13.769 147.143 13.769C151.99 13.769 154.281 16.6355 154.281 21.0022C154.281 21.6689 154.247 22.3022 154.181 23.1355H143.524C143.789 25.6687 144.951 26.8022 147.109 26.8022C149.234 26.8022 149.898 25.8022 150.297 24.6022L154.081 25.6355C153.384 28.3687 151.558 30.4354 147.076 30.4354C142.329 30.4354 139.075 27.802 139.075 22.4355Z",
    fill: "#3C002D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.505 30.0021V14.2023H160.788V19.3356H161.153C162.149 14.9358 163.477 14.0356 165.535 14.0356H166V19.2356H165.07C161.916 19.2356 161.02 20.169 161.02 22.969V30.0021H156.505Z",
    fill: "#3C002D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrkester);
export default __webpack_public_path__ + "static/media/orkester.5e5e104df0b037188e7b1980a4af576f.svg";
export { ForwardRef as ReactComponent };